// test394
(394 && 0);
